const authEndpoints = {
  signup: {
    method: "POST",
    path: "/auth/signup",
    credentials: "include",
    acceptAccessToken: true,
  },
  login: {
    method: "POST",
    path: "/auth/login",
    credentials: "include",
    acceptAccessToken: true,
  },
  refresh: {
    method: "POST",
    path: "/auth/refresh",
    credentials: "include",
    acceptAccessToken: true,
  },
  logout: {
    method: "POST",
    path: "/auth/logout",
    credentials: "include",
    clearAccessToken: true,
  },
  resetPassword: {
    method: "PATCH",
    path: "/auth/reset-password",
  },
};

export default authEndpoints;
